import { type FoundingMapItem, FoundingMapItemModel } from './founding-map-item.model';

export interface NewFoundingMapItem {
    foundingYear: string;
    foundingCategories: Array<string>;
    ideaDescription: string;
}

export class NewFoundingMapItemModel extends FoundingMapItemModel {
    public foundingYear: string;
    public foundingCategories: Array<string>;
    public ideaDescription: string;

    constructor(item: FoundingMapItem & NewFoundingMapItem) {
        super(item);

        this.foundingYear = item.foundingYear;
        this.foundingCategories = item.foundingCategories;
        this.ideaDescription = item.ideaDescription;
    }
}
